var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('Mapa'),_c('p',{staticStyle:{"font-size":"14px","text-align":"center"}},[_vm._v("Puedes ajustar la dirección.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }